// extracted by mini-css-extract-plugin
export default {"RulesPanelProtectionsHeader":"RulesPanel-module__RulesPanelProtectionsHeader--vzstn","RulesPanelProtectionsContainer":"RulesPanel-module__RulesPanelProtectionsContainer--JIzM6"};